// CRM mock data \u2014 customers with full history, invoices, properties, equipment, notes
export const customerList = [
  {
    id: "c1",
    name: "Jennifer Williams",
    type: "Residential",
    phone: "(602) 412-9981",
    altPhone: "",
    email: "jen.williams@email.com",
    address: "4821 N Camelback Rd",
    city: "Phoenix",
    state: "AZ",
    zip: "85016",
    tags: ["VIP", "Membership"],
    lifetimeValue: 18420,
    openBalance: 0,
    jobsCount: 14,
    rating: 5,
    since: "2019-03-12",
    lastService: "2025-06-28",
    notes: "Prefers morning appointments. Two large dogs in backyard \u2014 call before arrival. Platinum membership renews March 2026.",
    properties: [
      { id: "p1", label: "Primary Residence", address: "4821 N Camelback Rd, Phoenix, AZ 85016", sqft: 3400, units: 1 },
    ],
    equipment: [
      { id: "e1", type: "AC Condenser", brand: "Trane", model: "XR16", serial: "TX-44128-A", installedAt: "2021-04-22", warranty: "10 yr parts" },
      { id: "e2", type: "Air Handler", brand: "Trane", model: "TEM6", serial: "TM-44128-B", installedAt: "2021-04-22", warranty: "10 yr parts" },
      { id: "e3", type: "Smart Thermostat", brand: "Ecobee", model: "Premium", serial: "EB-998211", installedAt: "2023-07-08", warranty: "3 yr" },
    ],
    history: [
      { id: "J-10428", date: "2025-07-08", type: "HVAC Repair", status: "In Progress", tech: "Marcus Johnson", value: 1240 },
      { id: "J-10434", date: "2025-07-08", type: "HVAC Tune-up", status: "Scheduled", tech: "Marcus Johnson", value: 180 },
      { id: "J-10302", date: "2025-04-15", type: "HVAC Tune-up", status: "Completed", tech: "Marcus Johnson", value: 180 },
      { id: "J-10218", date: "2024-10-08", type: "HVAC Tune-up", status: "Completed", tech: "Aisha Patel", value: 180 },
      { id: "J-10122", date: "2024-06-12", type: "Capacitor Replacement", status: "Completed", tech: "Marcus Johnson", value: 380 },
      { id: "J-10044", date: "2023-07-08", type: "Thermostat Install", status: "Completed", tech: "Diego Ramirez", value: 660 },
    ],
    invoices: [
      { id: "INV-8821", date: "2025-04-15", amount: 180, status: "Paid", method: "Visa ****4421" },
      { id: "INV-8602", date: "2024-10-09", amount: 180, status: "Paid", method: "ACH" },
      { id: "INV-8410", date: "2024-06-13", amount: 380, status: "Paid", method: "Visa ****4421" },
      { id: "INV-7920", date: "2023-07-09", amount: 660, status: "Paid", method: "Check #1042" },
    ],
  },
  {
    id: "c2",
    name: "Coronado Plaza HOA",
    type: "Commercial",
    phone: "(602) 555-3122",
    altPhone: "(602) 555-3123",
    email: "manager@coronadoplaza.com",
    address: "812 E Coronado Rd",
    city: "Phoenix",
    state: "AZ",
    zip: "85006",
    tags: ["Net-30", "Multi-property"],
    lifetimeValue: 142800,
    openBalance: 4280,
    jobsCount: 38,
    rating: 4,
    since: "2018-06-04",
    lastService: "2025-07-02",
    notes: "Net-30 billing. Dispatch property manager Karen Becker for emergency calls. Three buildings on the property \u2014 see properties tab.",
    properties: [
      { id: "p1", label: "Building A \u2014 North Tower", address: "812 E Coronado Rd, Phoenix, AZ 85006", sqft: 24000, units: 18 },
      { id: "p2", label: "Building B \u2014 South Tower", address: "820 E Coronado Rd, Phoenix, AZ 85006", sqft: 24000, units: 18 },
      { id: "p3", label: "Clubhouse & Pool", address: "830 E Coronado Rd, Phoenix, AZ 85006", sqft: 6800, units: 1 },
    ],
    equipment: [
      { id: "e1", type: "Rooftop Unit (5T)", brand: "Carrier", model: "48HC-D06", serial: "C-22-0411", installedAt: "2022-03-18", warranty: "5 yr" },
      { id: "e2", type: "Rooftop Unit (5T)", brand: "Carrier", model: "48HC-D06", serial: "C-22-0412", installedAt: "2022-03-18", warranty: "5 yr" },
      { id: "e3", type: "Pool Heater", brand: "Raypak", model: "P-R406A", serial: "RY-118822", installedAt: "2020-08-04", warranty: "Expired" },
    ],
    history: [
      { id: "J-10429", date: "2025-07-08", type: "Plumbing Service", status: "Scheduled", tech: "Sara Chen", value: 820 },
      { id: "J-10380", date: "2025-06-18", type: "HVAC Tune-up (Quarterly)", status: "Completed", tech: "Aisha Patel", value: 4280 },
      { id: "J-10298", date: "2025-04-04", type: "HVAC Tune-up (Quarterly)", status: "Completed", tech: "Marcus Johnson", value: 4280 },
      { id: "J-10211", date: "2025-01-20", type: "HVAC Tune-up (Quarterly)", status: "Completed", tech: "Aisha Patel", value: 4180 },
      { id: "J-10180", date: "2024-12-05", type: "Pool Heater Service", status: "Completed", tech: "Tom O'Brien", value: 880 },
      { id: "J-10102", date: "2024-09-14", type: "Compressor Replacement \u2014 Building A", status: "Completed", tech: "Aisha Patel", value: 5840 },
    ],
    invoices: [
      { id: "INV-9120", date: "2025-07-02", amount: 4280, status: "Open", method: "Net-30 \u2014 due Aug 1" },
      { id: "INV-8902", date: "2025-06-18", amount: 4280, status: "Paid", method: "ACH" },
      { id: "INV-8805", date: "2025-04-04", amount: 4280, status: "Paid", method: "ACH" },
      { id: "INV-8612", date: "2025-01-20", amount: 4180, status: "Paid", method: "ACH" },
    ],
  },
  {
    id: "c3",
    name: "Robert Hayes",
    type: "Residential",
    phone: "(602) 555-8814",
    altPhone: "",
    email: "r.hayes@email.com",
    address: "2210 W Bethany Home Rd",
    city: "Phoenix",
    state: "AZ",
    zip: "85015",
    tags: ["Membership"],
    lifetimeValue: 6820,
    openBalance: 0,
    jobsCount: 7,
    rating: 5,
    since: "2022-09-21",
    lastService: "2025-07-01",
    notes: "Silver membership. Side gate code 4422. Water-heater nearing end of life \u2014 quoted replacement.",
    properties: [
      { id: "p1", label: "Primary Residence", address: "2210 W Bethany Home Rd, Phoenix, AZ 85015", sqft: 1820, units: 1 },
    ],
    equipment: [
      { id: "e1", type: "AC Condenser", brand: "Goodman", model: "GSXC18", serial: "GD-009281", installedAt: "2018-05-04", warranty: "Expired" },
      { id: "e2", type: "Tankless Water Heater", brand: "Rinnai", model: "RU199i", serial: "RN-228114", installedAt: "2014-10-22", warranty: "Expired" },
    ],
    history: [
      { id: "J-10430", date: "2025-07-08", type: "Electrical Inspection", status: "Completed", tech: "Diego Ramirez", value: 320 },
      { id: "J-10336", date: "2025-05-12", type: "HVAC Tune-up", status: "Completed", tech: "Marcus Johnson", value: 180 },
      { id: "J-10240", date: "2024-11-08", type: "Drain Cleaning", status: "Completed", tech: "Tom O'Brien", value: 240 },
      { id: "J-10141", date: "2024-07-11", type: "Capacitor Replacement", status: "Completed", tech: "Marcus Johnson", value: 380 },
    ],
    invoices: [
      { id: "INV-8901", date: "2025-07-01", amount: 320, status: "Paid", method: "Mastercard ****8821" },
      { id: "INV-8704", date: "2025-05-12", amount: 180, status: "Paid", method: "Mastercard ****8821" },
    ],
  },
  {
    id: "c4",
    name: "Desert Sun Apartments",
    type: "Commercial",
    phone: "(602) 555-1900",
    altPhone: "",
    email: "ops@desertsun.com",
    address: "1500 E Indian School Rd",
    city: "Phoenix",
    state: "AZ",
    zip: "85014",
    tags: ["VIP", "Net-15"],
    lifetimeValue: 98400,
    openBalance: 1820,
    jobsCount: 22,
    rating: 4,
    since: "2020-01-14",
    lastService: "2025-06-30",
    notes: "Property manager: David Lin. Maintenance window: 7 AM \u2013 11 AM weekdays only. No pets registered with leasing office.",
    properties: [
      { id: "p1", label: "Building A", address: "1500 E Indian School Rd, Phoenix, AZ 85014", sqft: 18000, units: 24 },
      { id: "p2", label: "Building B", address: "1510 E Indian School Rd, Phoenix, AZ 85014", sqft: 18000, units: 24 },
    ],
    equipment: [
      { id: "e1", type: "Boiler", brand: "Burnham", model: "MPC-65", serial: "BN-77118", installedAt: "2015-09-22", warranty: "Expired" },
      { id: "e2", type: "Rooftop Unit (3T)", brand: "Lennox", model: "Strategos", serial: "LX-44012", installedAt: "2021-06-08", warranty: "10 yr" },
    ],
    history: [
      { id: "J-10431", date: "2025-07-08", type: "HVAC Install", status: "Dispatched", tech: "Aisha Patel", value: 6840 },
      { id: "J-10355", date: "2025-06-04", type: "Plumbing Service", status: "Completed", tech: "Sara Chen", value: 1820 },
      { id: "J-10288", date: "2025-03-19", type: "HVAC Tune-up", status: "Completed", tech: "Marcus Johnson", value: 2840 },
    ],
    invoices: [
      { id: "INV-9001", date: "2025-06-30", amount: 1820, status: "Open", method: "Net-15 \u2014 due Jul 15" },
      { id: "INV-8520", date: "2025-03-20", amount: 2840, status: "Paid", method: "ACH" },
    ],
  },
  {
    id: "c5",
    name: "Emily Carter",
    type: "Residential",
    phone: "(480) 555-4421",
    altPhone: "",
    email: "e.carter@email.com",
    address: "3340 E Thomas Rd",
    city: "Phoenix",
    state: "AZ",
    zip: "85018",
    tags: [],
    lifetimeValue: 2240,
    openBalance: 240,
    jobsCount: 3,
    rating: 4,
    since: "2024-01-08",
    lastService: "2025-06-15",
    notes: "New customer \u2014 referred by James Liu. Lives alone, prefers text confirmation.",
    properties: [
      { id: "p1", label: "Primary Residence", address: "3340 E Thomas Rd, Phoenix, AZ 85018", sqft: 1240, units: 1 },
    ],
    equipment: [
      { id: "e1", type: "AC Condenser", brand: "Carrier", model: "24ABC6", serial: "CR-002284", installedAt: "2017-08-12", warranty: "Expired" },
    ],
    history: [
      { id: "J-10432", date: "2025-07-08", type: "Drain Cleaning", status: "Scheduled", tech: "Tom O'Brien", value: 280 },
      { id: "J-10310", date: "2025-04-22", type: "HVAC Diagnostic", status: "Completed", tech: "Marcus Johnson", value: 240 },
    ],
    invoices: [
      { id: "INV-9015", date: "2025-06-15", amount: 240, status: "Open", method: "On account" },
      { id: "INV-8740", date: "2025-04-22", amount: 240, status: "Paid", method: "Visa ****1144" },
    ],
  },
  {
    id: "c6",
    name: "James Liu",
    type: "Residential",
    phone: "(602) 555-6618",
    altPhone: "",
    email: "james.liu@email.com",
    address: "6622 N 7th St",
    city: "Phoenix",
    state: "AZ",
    zip: "85014",
    tags: ["Membership", "Referrer"],
    lifetimeValue: 11240,
    openBalance: 0,
    jobsCount: 9,
    rating: 5,
    since: "2021-11-02",
    lastService: "2025-07-03",
    notes: "Active referrer \u2014 brought in 3 customers. Gold membership. Smart home enthusiast.",
    properties: [
      { id: "p1", label: "Primary Residence", address: "6622 N 7th St, Phoenix, AZ 85014", sqft: 2400, units: 1 },
    ],
    equipment: [
      { id: "e1", type: "Variable-Speed Air Handler", brand: "Trane", model: "TAM9", serial: "TR-118822", installedAt: "2024-05-12", warranty: "10 yr" },
      { id: "e2", type: "Heat Pump", brand: "Trane", model: "XV20i", serial: "TR-118823", installedAt: "2024-05-12", warranty: "12 yr" },
    ],
    history: [
      { id: "J-10433", date: "2025-07-08", type: "Panel Upgrade", status: "Scheduled", tech: "Priya Kapoor", value: 2840 },
      { id: "J-10322", date: "2025-05-04", type: "HVAC Tune-up", status: "Completed", tech: "Aisha Patel", value: 180 },
    ],
    invoices: [
      { id: "INV-8830", date: "2025-05-04", amount: 180, status: "Paid", method: "Apple Pay" },
    ],
  },
  {
    id: "c7",
    name: "Marriott Phoenix",
    type: "Commercial",
    phone: "(602) 555-7700",
    altPhone: "(602) 555-7701",
    email: "engineering@marriott-phx.com",
    address: "1 N 2nd St",
    city: "Phoenix",
    state: "AZ",
    zip: "85004",
    tags: ["VIP", "Net-45"],
    lifetimeValue: 218400,
    openBalance: 0,
    jobsCount: 47,
    rating: 5,
    since: "2017-04-22",
    lastService: "2025-07-08",
    notes: "Largest commercial account. PO required for all work over $1,000. Engineering contact: Mark O'Reilly.",
    properties: [
      { id: "p1", label: "Main Tower", address: "1 N 2nd St, Phoenix, AZ 85004", sqft: 380000, units: 320 },
    ],
    equipment: [
      { id: "e1", type: "Chiller \u2014 500-Ton", brand: "York", model: "YK-500", serial: "YK-001140", installedAt: "2018-09-04", warranty: "5 yr" },
    ],
    history: [
      { id: "J-10440", date: "2025-07-08", type: "HVAC Install", status: "Scheduled", tech: "Marcus Johnson", value: 5240 },
      { id: "J-10402", date: "2025-06-22", type: "Cooling Tower Service", status: "Completed", tech: "Aisha Patel", value: 4880 },
    ],
    invoices: [
      { id: "INV-9020", date: "2025-06-22", amount: 4880, status: "Paid", method: "Wire" },
    ],
  },
  {
    id: "c8",
    name: "Sandra Park",
    type: "Residential",
    phone: "(480) 555-2284",
    altPhone: "",
    email: "s.park@email.com",
    address: "2210 W Indian School",
    city: "Phoenix",
    state: "AZ",
    zip: "85015",
    tags: [],
    lifetimeValue: 1480,
    openBalance: 0,
    jobsCount: 1,
    rating: 0,
    since: "2025-07-03",
    lastService: "2025-07-08",
    notes: "First-time customer \u2014 emergency water heater call.",
    properties: [
      { id: "p1", label: "Primary Residence", address: "2210 W Indian School, Phoenix, AZ 85015", sqft: 1620, units: 1 },
    ],
    equipment: [],
    history: [
      { id: "J-10441", date: "2025-07-08", type: "Water Heater", status: "Scheduled", tech: "Sara Chen", value: 1480 },
    ],
    invoices: [],
  },
];

export const customerStatusColors = {
  Paid: { bg: "#DCFCE7", text: "#166534" },
  Open: { bg: "#FEF3C7", text: "#92400E" },
  Overdue: { bg: "#FEE2E2", text: "#991B1B" },
  Completed: { bg: "#E5E7EB", text: "#374151" },
  Scheduled: { bg: "#DBEAFE", text: "#1E40AF" },
  Dispatched: { bg: "#FEF3C7", text: "#92400E" },
  "In Progress": { bg: "#DCFCE7", text: "#166534" },
};
